import electricalUrl1 from "../components/repair/one.jpg";
import electricalUrl3 from "../components/repair/three.jpg";
import electricalUrl4 from "../components/repair/four.jpg";
import wiring from "../components/repair/wiring.jpg";
import plumber from "../components/plumbing/plumber1.jpg";
import drainage from "../components/plumbing/drainage.jpg";
import irrigation from "../components/plumbing/irrigation.jpg";
import roofing from "../components/plumbing/roofing.jpg";

const projectsData = [
  {
    src: electricalUrl1,
    status: "electrical",
    title: "Lighting and electricaling",
    message:
      "Efficient lighting solutions and expert electrical services available.",
  },
  {
    src: plumber,
    status: "plumbing",
    title: "Install pipe and Maintenance",
    message:
      "Professional pipe installation and maintenance services for your convenience.",
  },
  {
    src: electricalUrl3,
    status: "electrical",
    title: "Electrical Wiring Upgrade",
    message:
      "Upgrade your electrical wiring for improved safety and efficiency.",
  },
  {
    src: roofing,
    status: "plumbing",
    title: "Leak Detection and electrical",
    message:
      "Expert leak detection and electrical services to safeguard your property.",
  },
  {
    src: electricalUrl3,
    status: "electrical",
    title: "Appliance Installation",
    message:
      "Professional appliance installation services for seamless integration.",
  },
  {
    src: drainage,
    status: "plumbing",
    title: "Drain Cleaning and Unclogging",
    message:
      "Efficient drain cleaning and unclogging services to keep your pipes clear.",
  },
  {
    src: electricalUrl4,
    status: "electrical",
    title: "Circuit Breaker Replacement",
    message: "Replace old circuit breakers to ensure safety and reliability.",
  },
  {
    src: irrigation,
    status: "plumbing",
    title: "Water Heater Installation",
    message:
      "Professional water heater installation services for hot water on demand.",
  },
  {
    src: wiring,
    status: "electrical",
    title: "Faulty Outlet electrical",
    message:
      "Quick and reliable electrical of faulty electrical outlets for your convenience.",
  },
];

export default projectsData;
